<template>
  <div class="checkin-online">
    <content-section title="Check-in Online">
      <span v-if="checkin_online_info" v-html="checkin_online_info"></span>
      <span v-else>
        Questo documento e il codice riportato in questa email non ti
        danno diritto all'imbarco. Per effettuare l'imbarco devi
        effettuare il check-in online prima della partenza. Il check-in
        online va obbligatoriamente effettuato sul sito della compagnia
        aerea nei termini e nelle modalità indicate sul sito stesso. Ti
        invitiamo a visitare e consultare il sito della compagnia aerea
        con attenzione
      </span>
    </content-section>
  </div>
</template>

<script>
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";

export default {
  name: "checkin-online",

  components: {
    "content-section": ContentSection,
  },

  props: {
    // testo del check-in online fornito dal provider; se assente si mostra il copy di default
    checkin_online_info: {
      type: String,
      default: "",
    },
  },
};
</script>